<div>
  <div mat-card-title>User wise served orders</div>
  <div class="mt-2 p-1">
    <nz-table #nzTable [nzData]="userWiseOrders" nzTableLayout="fixed" nzShowPagination="false" nzBordered
      nzShowSizeChanger nzOuterBordered>
      <thead>
        <tr>
          <th class="text-center">User</th>
          <th class="text-center">Served Orders</th>
        </tr>
      </thead>
      <tbody>
        @for (data of nzTable.data; track data) {
          <tr>
            <td> {{ data.createdByName }}</td>
            <td class="text-center">{{data.orderCount}}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</div>
